{
  "Clear search": "Fjern søk"
}
